import { cn } from '@/shadcn-ui/utils';
import Stripe from '@/icons/stripe';

interface SecuredByStripeBlurbProps {
  className?: string;
}

export default function SecuredByStripeBlurb({ className }: SecuredByStripeBlurbProps) {
  return (
    <p className={cn('body2 text-center text-flexcar-neutral50', className)}>
      Transactions are encrypted and secured by
      <Stripe className="inline" />
    </p>
  );
}
